import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { INTTTokenRequest, INTTTokenResponse } from './models';

const TAG = ApiTags.Payment;

const nttApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getToken: builder.mutation<INTTTokenResponse, INTTTokenRequest>({
      query: (model) => ({
        url: '/Payments/NTT',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    }),
  })
})

export const {
  useGetTokenMutation
} = nttApi;